import { InputLabel, TextLabel } from '../../../../../common/components/form/fields';
import { FORM_RULES } from "../../../../../helpers/validations";

const inputStyle = { fontSize: "1.6rem", padding: 20, borderRadius: "1rem" };
const style = { textAlign: "left", fontSize: "1.6rem" };

export default () => [
	{
		component: InputLabel,
		type: "text",
		name: "name",
        label: "Nome",
        placeholder:"Nome",
		cols: "12 12 12 12",
		validate: [FORM_RULES.required],
		style,
		inputStyle
	},
	{
		component: TextLabel,
		type: "text",
		name: "description",
        label: "Descrição da permissão",
        placeholder:"Permissão para acesso a funcionalidade x...",
		cols: "12 12 12 12",
		rows: 4,
		validate: [FORM_RULES.required],
		style,
		inputStyle
	}
];
